import React from 'react';
import styled from 'styled-components';

const FlowchartColumn = ({data}) => {
	return (
		<FlowchartColumnNodeDiv>
			<p className="title">{data.title}</p>
		</FlowchartColumnNodeDiv>
	);
};

export default FlowchartColumn;

const FlowchartColumnNodeDiv = styled.div`
	padding: 5px 10px;
	width: 100%;
	height: 100%;
	border: 1px solid black;
	z-index: -1;
	.title {
		font-weight: 400;
		font-size: 12px;
		color: rgba(77, 77, 92, 1);
	}
`;
